const SHIFT_DOMAIN = 'shift'

/**
 * Whether the visitor asked for a shift domain, which is what picks the Yahoo
 * home layout. useRequestURL reads the request on the server and
 * window.location in the browser, so a server render answers with the host the
 * visitor used instead of deciding the layout without one and having the
 * browser swap it after hydration.
 */
export function isShift(): boolean {
  const host = useRequestURL().hostname
  return host.includes(SHIFT_DOMAIN)
}
